import { sortCaps } from "../../utils/adjustedCapsUtil";
import { processDate } from "../../utils/dateProcessor";
import {
  setANGIETotals,
  setEBITDATotals,
  setNGIETotals,
  setQNGIETotals,
} from "./GroupDataCalcs";
//[TODO] remove the use of this method
const calculateComponentTotals = (poa) => {
  // NGIE section
  setNGIETotals(poa);

  // ANGIE section
  setANGIETotals(poa);

  // EBITDA section
  setEBITDATotals(poa);

  // QNGIE section
  setQNGIETotals(poa);

  return poa;
};

const getBFDTotal = (type, poa) => {
  const sorted_caps = sortCaps(poa?.adjusted_caps);
  let total = 0;
  sorted_caps?.forEach((cap, index) => {
    const prevComp =
      index > 0 ? poa?.adjusted_caps[index - 1]?.company_ID : null;
    // for first AP of each company
    if (index === 0 || cap?.company_ID !== prevComp) {
      const property = type + "_subtotal_gbp";
      total +=
        cap?.hasOwnProperty(property) && !Number.isNaN(cap[property])
          ? cap[property]
          : 0;
    }
  });
  return total;
};

export { calculateComponentTotals, getBFDTotal };
